<button (click)="onCopyClicked()"
        [cdkCopyToClipboard]="value"
        [matTooltip]="tooltip"
        mat-icon-button
        aria-label="Copy to clipboard"
        type="button"
>
  <mat-icon>content_copy</mat-icon>
</button>
